export class CourseOfferingAudienceCommand {
    linked_audiences: { id: string }[];

    constructor(query: { id: string }[]) {
        this.linked_audiences = query.map((linkedAudience) => ({ id: linkedAudience.id }));
    }
}
